module.exports = __webpack_public_path__ + "img/suit-01.f1c47f77.png";